export default __webpack_public_path__ + "2014 Quantum nonlinear optics with polar J-aggregates.pdf";